module.exports = "/images/off_road_grey.png?0978cbcaf01d710d1798e88404683a43";